import axios, { AxiosResponse } from 'axios'
import {
  ID,
  WoosatTelecomResponse,
  Response,
} from '../../../../../_metronic/helpers'
import { Hawala, HawalasQueryResponse } from './_models'
import toast from 'react-hot-toast'

const API_URL = process.env.REACT_APP_THEME_API_URL
const HAWALA_URL = `${API_URL}/admin/hawala-orders`

const getHawalas = (query: string): Promise<HawalasQueryResponse | WoosatTelecomResponse<Hawala[]>> => {
  return axios
    .get(`${HAWALA_URL}?${query}`)
    .then((d: AxiosResponse<WoosatTelecomResponse<Hawala[]>>) => d.data)
}

const getHawalaById = async (id: ID): Promise<Hawala> => {
  try {
    const { data } = await axios.get(`${HAWALA_URL}/${id}`)
    return data?.data?.order
  } catch (error: any) {
    console.error('Error fetching hawala by ID:', error.message)
    return {} as Hawala
  }
}

const createHawala = (hawala: Hawala): Promise<Hawala | undefined> => {
  return axios
    .post(HAWALA_URL, hawala)
    .then((response: AxiosResponse<Response<Hawala>>) => response.data.data)
}

const updateHawala = (hawala: Hawala): Promise<Hawala | undefined> => {
  return axios
    .put(`${HAWALA_URL}/${hawala.id}`, hawala)
    .then((response: AxiosResponse<Response<Hawala>>) => response.data.data)
}

const deleteHawala = (hawalaId: ID): Promise<void> => {
  return axios.delete(`${HAWALA_URL}/${hawalaId}`).then((response) => {
    const msg = response?.data?.message
    response.data.success
      ? toast.success(msg, { position: 'top-right' })
      : toast.error(msg, { position: 'top-right' })
  })
}

const setHawalaUnderProcess = (hawalaId: ID): Promise<void> => {
  return axios.get(`${HAWALA_URL}/underprocess-hawala/${hawalaId}`).then((response) => {
    const msg = response?.data?.message
    response.data.success
      ? toast.success(msg, { position: 'top-right' })
      : toast.error(msg, { position: 'top-right' })
  })
}

const confirmHawala = (hawalaId: ID): Promise<void> => {
  return axios.post(`${HAWALA_URL}/confirm/${hawalaId}`).then((response) => {
    const msg = response?.data?.message
    response.data.success
      ? toast.success(msg, { position: 'top-right' })
      : toast.error(msg, { position: 'top-right' })
  })
}

const rejectHawala = (hawalaId: ID, rejectReason: string): Promise<void> => {
  return axios
    .post(`${HAWALA_URL}/reject/${hawalaId}`, { admin_note: rejectReason })
    .then((response) => {
      const msg = response?.data?.message
      response.data.success
        ? toast.success(msg, { position: 'top-right' })
        : toast.error(msg, { position: 'top-right' })
    })
}

const deleteSelectedHawalas = (hawalaIds: Array<ID>): Promise<void> => {
  const requests = hawalaIds.map((id) => axios.delete(`${HAWALA_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getHawalas,
  getHawalaById,
  createHawala,
  updateHawala,
  deleteHawala,
  deleteSelectedHawalas,
  setHawalaUnderProcess,
  confirmHawala,
  rejectHawala,
}
